module.exports = __webpack_public_path__ + "static/media/vspaceteam.a04a36ec.png";